'use client';

import { Navigate, Outlet } from 'react-router-dom';

import { DashboardNav } from '@/components/dashboard-nav';
import { DebugPanel } from '@/components/debug-panel';
import { useAuth } from '@/hooks/use-auth';
import { useOrg } from '@/hooks/use-org';

export function DashboardLayout(): import('react/jsx-runtime').JSX.Element {
  const { user, isLoading } = useAuth();
  const { orgName, activeOrg, orgs, isLoading: orgsLoading } = useOrg();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-muted border-t-foreground" />
      </div>
    );
  }

  if (user == null) {
    return <Navigate to="/login" replace />;
  }

  // If auth settled and no org exists yet, send to onboarding.
  if (!orgsLoading && orgs.length === 0) {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900/50 via-background to-background">
      <DashboardNav user={user} orgName={orgName} />
      <main className="flex-1 animate-fade-in">
        <Outlet />
      </main>
      <DebugPanel />
    </div>
  );
}
